import svgUrl from "ni:svgr;diYfxKRHkWzoxlwTcJy0fQRFFqRUUQPIOTvlgEGJC6g";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiFilterSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M2.303 4.4C1.56 3.411 2.267 2 3.503 2h8c1.236 0 1.941 1.411 1.2 2.4l-3.4 4.533a1.5 1.5 0 0 0-.3.9v2.799c0 .501-.25.97-.668 1.248L6.78 14.916a.5.5 0 0 1-.777-.416V9.833a1.5 1.5 0 0 0-.3-.9L2.303 4.4Zm1.2-1.4a.5.5 0 0 0-.4.8l3.4 4.533c.324.433.5.96.5 1.5v3.733l.777-.519a.5.5 0 0 0 .223-.415V9.833a2.5 2.5 0 0 1 .5-1.5l3.4-4.533a.5.5 0 0 0-.4-.8h-8Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiFilterSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiFilterSIcon)";
}